import { PageContainer } from '../components/layout/PageContainer'
import HeroSearch from '../components/home/HeroSearch'
import TaskEntryCards from '../components/home/TaskEntryCards'
import UrgencyBar from '../components/home/UrgencyBar'
import CategoryHighlights from '../components/home/CategoryHighlights'
import InStockBand from '../components/home/InStockBand'
import ValueBand from '../components/home/ValueBand'
import type { Category, ProductCard } from '../types'

interface HomePageProps {
  /** SSR-seeded from pages/home/+data so the category + product grids render in
   *  the server HTML. Omitted on the client SPA shell (the widgets then fetch). */
  initialCategories?: Category[]
  initialFeatured?: ProductCard[]
}

/**
 * Homepage v2 (T3.2). Task-first, top to bottom (verbeterplan §6.1):
 *   1. Hero = search bar          → HeroSearch
 *   2. Three task entrances       → TaskEntryCards
 *   3. Urgency / engineer line    → UrgencyBar
 *   4. Main categories            → CategoryHighlights (SSR-seeded)
 *   5. Orderable, priced products → InStockBand (SSR-seeded; hides if empty, G13)
 *   6. Trust / why GCG            → ValueBand
 * All copy runs through i18n (G9). Rendered server-side (pages/home/+data).
 */
export default function HomePage({ initialCategories, initialFeatured }: HomePageProps = {}) {
  return (
    <div>
      {/* 1 — Hero is the search bar */}
      <HeroSearch />

      <PageContainer>
        {/* 2 — Three task entrances */}
        <TaskEntryCards />
      </PageContainer>

      {/* 3 — Engineer line as a proposition, full-width band */}
      <UrgencyBar />

      <PageContainer>
        {/* 4 — Main categories */}
        <CategoryHighlights initialData={initialCategories} />

        {/* 5 — Orderable, priced products (self-hides when empty) */}
        <InStockBand initialData={initialFeatured} />
      </PageContainer>

      {/* 6 — Trust / why GCG, full-width bg */}
      <ValueBand />
    </div>
  )
}
